var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmployeeRepoting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 17.2876H16.3033C15.57 17.2876 14.8733 17.5718 14.36 18.0851L12.7925 19.6343C12.0775 20.3401 10.9133 20.3401 10.1983 19.6343L8.63083 18.0851C8.1175 17.5718 7.41167 17.2876 6.6875 17.2876H6C4.47833 17.2876 3.25 16.0685 3.25 14.5651V4.56427C3.25 3.06094 4.47833 1.8418 6 1.8418H17C18.5217 1.8418 19.75 3.06094 19.75 4.56427V14.5651C19.75 16.0593 18.5217 17.2876 17 17.2876Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5001 9.16617C12.6797 9.16617 13.636 8.20991 13.636 7.03032C13.636 5.85074 12.6797 4.89453 11.5001 4.89453C10.3205 4.89453 9.36426 5.85074 9.36426 7.03032C9.36426 8.20991 10.3205 9.16617 11.5001 9.16617Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1668 14.3555C15.1668 12.7055 13.526 11.3672 11.5002 11.3672C9.47433 11.3672 7.8335 12.7055 7.8335 14.3555",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeRepoting);
export default __webpack_public_path__ + "static/media/employee-repoting.3dd51a34ab6455c878784d0081abd920.svg";
export { ForwardRef as ReactComponent };